const delimiters = {
    en: ',',
    ru: ';'
};

const isNumeric = (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
};

class CSV {
    constructor(params = {}) {
        this.lang = this.getLanguage();
        this.lineDelimiter = params.lineDelimiter || '\n';
        this.columnDelimiter = delimiters[this.lang];
    }

    getValue(value) {
        if (isNumeric(value)) {
            value = ('' + value).replace(/\./g, ',');
        }

        return `"${value}"`;
    }

    convert(data = null) {
        let result = '';

        if (data === null || !data.length) {
            return null;
        }

        data.forEach((item) => {
            if (Array.isArray(item)) {
                result += item.map((value) => this.getValue(value)).join(this.columnDelimiter);
            } else {
                Object.keys(item).map(key => this.getValue(item[key])).join(this.columnDelimiter);
            }
            result += this.lineDelimiter;
        });

        return result;
    }

    download(csv = null, fileName = 'export') {
        if (csv === null) return;

        const mimeType = 'text/plain;charset=utf-8';
        let a = document.createElement('a');
        fileName = fileName.replace(/ /g, "_") + '.csv';

        if (navigator.msSaveBlob) { // IE10
            navigator.msSaveBlob(new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), csv], {
                type: mimeType
            }), fileName);
        } else if (URL && 'download' in a) { //html5 A[download]
            a.href = URL.createObjectURL(new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), csv], {
                type: mimeType
            }));
            a.setAttribute('download', fileName);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } else {
            location.href = `data:application/octet-stream,${encodeURIComponent(csv)}`;
        }
    }

    getLanguage() {
        const lang = window.navigator.language || navigator.userLanguage;
        const ln = lang.match(/ru|en/) || [];

        return ln[0] || 'en';
    }
}

export default CSV;
